import type {
  PlayerAchievementsPublic,
  TournamentPublic,
  V2ExperienceRequestDetail,
} from "@softmax/observatory-client/types";
import { buildHref } from "@softmax/web-addresses";
import {
  appendResourceSearch,
  type PublicDetailInput,
} from "./resource-search";
import { admitPublicDetail, readResource } from "./resource-reader";
export async function loadPublicPlayer({
  signal,
  data: input,
}: {
  signal?: AbortSignal | undefined;
  data: PublicDetailInput;
}) {
  const destination = { name: "player", playerId: input.resourceId } as const;
  await admitPublicDetail({
    signal,
    destination,
    search: input.search,
  });
  const {
    resource: achievements,
    viewer,
    generatedAt,
  } = await readResource<PlayerAchievementsPublic>({
    signal,
    path: `/v2/players/${encodeURIComponent(input.resourceId)}/achievements`,
    returnHref: appendResourceSearch({
      href: buildHref(destination),
      search: input.search,
    }),
  });
  return { achievements, viewer, generatedAt };
}
export async function loadPublicTournament({
  signal,
  data: input,
}: {
  signal?: AbortSignal | undefined;
  data: PublicDetailInput;
}) {
  const destination = {
    name: "tournament",
    tournamentId: input.resourceId,
  } as const;
  await admitPublicDetail({
    signal,
    destination,
    search: input.search,
  });
  const {
    resource: tournament,
    viewer,
    generatedAt,
  } = await readResource<TournamentPublic>({
    signal,
    path: `/v2/tournaments/${encodeURIComponent(input.resourceId)}`,
    returnHref: appendResourceSearch({
      href: buildHref(destination),
      search: input.search,
    }),
  });
  return { tournament, viewer, generatedAt };
}
export async function loadPublicExperienceRequest({
  signal,
  data: input,
}: {
  signal?: AbortSignal | undefined;
  data: PublicDetailInput;
}) {
  const destination = {
    name: "experienceRequest",
    requestId: input.resourceId,
  } as const;
  await admitPublicDetail({
    signal,
    destination,
    search: input.search,
  });
  const {
    resource: detail,
    viewer,
    generatedAt,
  } = await readResource<V2ExperienceRequestDetail>({
    signal,
    path: `/v2/experience-requests/${encodeURIComponent(input.resourceId)}`,
    returnHref: appendResourceSearch({
      href: buildHref(destination),
      search: input.search,
    }),
  });
  return { detail, viewer, generatedAt };
}
